import GetGreenroomInvitationsForMeeting from '@/connection/greenroom/get-greenroom-invitations-for-meeting';
import { GetGreenroomMeetingData } from '@/connection/greenroom/get-greenroom-meeting-data';
import { RootState } from '@/store/main';
import { serializeError } from '@/store/utils/serialize-error';
import { GreenroomInviteUserResponse } from '@/types/greenroom/profile.types';
import { ProjectState, ProjectStateReducerCreator } from '../types';

const fetchGreenroomMeetingReducer = (create: ProjectStateReducerCreator) => {
  return create.asyncThunk(
    async (
      { sessionUuid, forceRefetch }: { sessionUuid: string; forceRefetch?: boolean },
      { getState, rejectWithValue }
    ) => {
      try {
        const state = getState() as RootState;

        if (!forceRefetch) {
          const stateMeeting = (state.project as ProjectState).greenroomSessionMeetings?.[sessionUuid];
          if (stateMeeting) {
            return null;
          }
        }

        const meeting = await GetGreenroomMeetingData(sessionUuid);

        let invites: GreenroomInviteUserResponse[] = [];
        if (meeting?.meeting) {
          try {
            const invitesResponse = await GetGreenroomInvitationsForMeeting({ meeting: meeting.meeting });
            if (invitesResponse?.length) {
              invites = invitesResponse;
            }
          } catch (error) {
            console.error(error);
          }
        }

        return { sessionUuid, meeting, invites };
      } catch (error) {
        console.error(error);
        return rejectWithValue(serializeError(error));
      }
    },
    {
      fulfilled: (state, action) => {
        if (action.payload) {
          const sessionUuid = action.payload.sessionUuid;
          const meeting = action.payload.meeting;
          const invites = action.payload.invites;
          state.greenroomSessionMeetings[sessionUuid] = { meeting, invites };
        }
      },
      rejected: (_state, action) => {
        console.error(action.payload);
      },
    }
  );
};

export default fetchGreenroomMeetingReducer;
